<div class="modal-header" (click)="$event.stopPropagation()">
  <h4 class="modal-title"> {{title}}</h4>
</div>

<div class="modal-body">
  <ng-container *ngIf="!isPerformingAction">
    <div [innerHTML]="message"></div>

    <!-- If files are uploading then show below block starts -->
    <div class="uploaded-documents-container" *ngIf="files.length > 0">
      <div class="document document-to-upload" *ngFor="let file of files">
        <app-doc-icon [fileName]="getFileName(file.name)"></app-doc-icon>
        <span class="document-name">{{file.name}}</span>
        <span class="document-size">{{returnFileSizeInKB(file)}}</span>
        <div class="progress">
          <div class="progress-bar" [ngClass]="{'complete': file.progressBarWidth === 100 }" role="progressbar" [(style.width.%)]="file.progressBarWidth" [(attr.aria-valuenow)]="file.progressBarWidth" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
      </div>
      <div class="modal-title text-color-red" *ngIf="returnUploadFailedNumber > 0"> {{returnUploadFailedNumber}} file(s) are failed to upload </div>
    </div>
    <!-- If files are uploading then show below block ends -->
  </ng-container>

  <div class="home-tabs-loader" *ngIf="isPerformingAction">
    <div class="loader"></div>
        <p>Performing requested action...</p>
  </div>
</div>

<div class="modal-footer">
  <ng-container *ngIf="!isPerformingAction">
      <button type="button" class="dialog-btn dialog-primary" (click)="onAccept()" [disabled]="isPerformingAction || isFileUploading()">{{ btnOkText }}</button>
      <button *ngIf="btnCancelText !== null" type="button" class="dialog-btn dialog-secondary" (click)="onDecline()" [disabled]="isPerformingAction">{{ btnCancelText }}</button>
  </ng-container>
</div>

